var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useCallback } from 'react';
import { useRegisterMutationMiddleware } from 'react-admin';
import { useFormContext } from 'react-hook-form';
import getReferenceManyToManyFormField from './getReferenceManyToManyFormField';
import { useUpdateManyToManyReferences } from './useUpdateManyToManyReferences';
export var useRegisterManyToManyHandling = function (_a) {
    var filter = _a.filter, reference = _a.reference, resourceProp = _a.resource, through = _a.through, using = _a.using, perPage = _a.perPage;
    var updateManyToManyReferences = useUpdateManyToManyReferences();
    var form = useFormContext();
    var updateManyToMany = useCallback(function (resource, params, options, next) {
        // We execute the many-to-many operations in the onSuccess callback of the main mutation
        // so that all mutation modes are supported.
        // However, onSuccess being a side effect, react-query will consider the whole operation done as soon as the main
        // mutation is finished, which is not what we want as it would for instance re-enable the save button in the form.
        // This is why we return a promise here to take control over when the mutation is considered done.
        return new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
            var manyToManyFieldName, values, onSuccess, otherOptions, data, otherParams, _a, _b, manyToManyField, sanitizedData, error_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        manyToManyFieldName = getReferenceManyToManyFormField({
                            reference: reference,
                            resource: resourceProp,
                            through: through,
                        });
                        values = form.getValues();
                        onSuccess = options.onSuccess, otherOptions = __rest(options, ["onSuccess"]);
                        data = params.data, otherParams = __rest(params, ["data"]);
                        _a = data, _b = manyToManyFieldName, manyToManyField = _a[_b], sanitizedData = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, next(resource, __assign(__assign({}, otherParams), { data: sanitizedData }), __assign(__assign({}, otherOptions), { onSuccess: function (result) { return __awaiter(void 0, void 0, void 0, function () {
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: 
                                            // Once the mutation is done, we can update the many-to-many references using its result
                                            return [4 /*yield*/, updateManyToManyReferences({
                                                    filter: filter,
                                                    newReferences: values[manyToManyFieldName],
                                                    resourceId: result.id,
                                                    through: through,
                                                    using: using,
                                                    perPage: perPage,
                                                })];
                                            case 1:
                                                // Once the mutation is done, we can update the many-to-many references using its result
                                                _a.sent();
                                                // pessimistic mode expects the mutation result to be returned
                                                resolve(result);
                                                // Execute the original onSuccess callback
                                                if (onSuccess) {
                                                    onSuccess(result);
                                                }
                                                return [2 /*return*/];
                                        }
                                    });
                                }); } }))];
                    case 2:
                        _c.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _c.sent();
                        reject(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        form,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        JSON.stringify(filter),
        reference,
        resourceProp,
        through,
        updateManyToManyReferences,
        using,
        perPage,
    ]);
    useRegisterMutationMiddleware(updateManyToMany);
};
